import React from "react";
import { XCircleIcon, CheckCircle2Icon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { TransformCTA } from "../TransformCTA";
import { beforeItems, afterItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-102" data-mp="26k08sz0wlc8d">
      <div className="mx-auto max-w-6xl" data-id="element-103" data-mp="22m2ddegjhtwj">
        <SectionHeading kicker="From scattered references to a structured educational system" title="You have the information. Now give your references a clearer structure." intro={["As an aesthetic professional, you may already have access to educational materials covering laser physics, skin anatomy, pigmentation, vascular concerns, skin rejuvenation, and different laser technologies.", "The challenge isn’t necessarily finding more information. It’s organizing the information you already have so you can review relevant concepts more efficiently."]} data-id="element-104" data-mp="2zb1p53gc1dth" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-105" data-mp="1754b0fkglg9z">
          <div className="rounded-3xl bg-white p-6 ring-1 ring-alert/25 sm:p-8" data-id="element-106" data-mp="1c4gtyp87m37a">
            <p className="inline-block rounded-full bg-alert px-4 py-1.5 font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-107" data-mp="1c2cr8am1ra8l">
              Before
            </p>
            <h3 className="mt-4 font-display text-2xl font-bold uppercase leading-tight text-ink sm:text-3xl" data-id="element-108" data-mp="1327mk888mpy4">
              Disconnected educational resources
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-109" data-mp="t6mouma7cbu6">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-base text-muted" data-id="element-110" data-mp="fezjlwya7sz9">
                  <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-111" data-mp="jf9zc1bvlxrb" />
                  <span data-id="element-112" data-mp="5fh1lm1xmh9u">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy-900 p-6 text-white ring-2 ring-success/50 sm:p-8" data-id="element-113" data-mp="afd39en5pwm8">
            <p className="inline-block rounded-full bg-success px-4 py-1.5 font-display text-lg font-bold uppercase tracking-wide text-navy-950" data-id="element-114" data-mp="2c4j009l8f6ol">
              After
            </p>
            <h3 className="mt-4 font-display text-2xl font-bold uppercase leading-tight sm:text-3xl" data-id="element-115" data-mp="23bpg1yuubj4e">
              Your organized Clinical Blueprint™
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-116" data-mp="1yarpoyzofirt">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-base text-white/90" data-id="element-117" data-mp="2v2c2xbvuvglz">
                  <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-success" aria-hidden="true" data-id="element-118" data-mp="2r21l91ypb1ra" />
                  <span data-id="element-119" data-mp="2m0m1dd89f1ah">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-base text-muted" data-id="element-120" data-mp="2h5q706fjw1u7">
          The goal isn’t to replace your clinical judgment, professional qualifications, manufacturer
          instructions, or appropriate training. It’s to provide a more organized educational reference
          collection that supports your continuing professional development.
        </p>

        <TransformCTA headline="Yes, I want a more organized aesthetic laser reference system" label="Get My Complete Blueprint" data-id="element-121" data-mp="10jmo18u2hp24" />
      </div>
    </section>;
}